import {store} from "@arboxappv4/shared/src/redux/store";
import {courseSteps, flowOptions, groupRegistrationCourseSteps} from "../../FlowOptions";
import {setTriggerNextStep, updateStepper} from "@arboxappv4/shared/src/redux/stepperSlice";
import {stepOptions} from "../../StepOptions";
import {HUGIM_FORM_SETTINGS} from "../../../../../src/constants";

export const handleCourseNextStep = ({values, dispatch, setFieldValue}) => {
    const flags = store.getState().stepper.flags
    const flowName = store.getState().stepper.flowName
    const steps = store.getState().stepper.steps
    const course = flags.courseInfo ?? values.course // fallback just in case
    let shouldUpdateStepper = false
    let newFlowName = flowName;
    let newSteps = steps

    if([flowOptions.COURSE, flowOptions.DIRECT_COURSE].includes(flowName)) {
        if(flags.isChildRegistration) {
            shouldUpdateStepper = true
            newFlowName = flowOptions.COURSE_CHILD_REGISTRATION
            newSteps = groupRegistrationCourseSteps()
        }
    } else if([flowOptions.COURSE_CHILD_REGISTRATION].includes(flowName)) {
        if(!flags.isChildRegistration) {
            if(values?.child) {
                setFieldValue('child', null)
            }
            shouldUpdateStepper = true
            newFlowName = flowOptions.COURSE
            newSteps = courseSteps()
        }
    }
    const res = handleHugFormStep({course, steps: newSteps, values, setFieldValue})
    newSteps = res.newSteps
    shouldUpdateStepper = shouldUpdateStepper || res.shouldUpdateStepper //"OR" operand is important here, don't change (can be false from handleHugFormStep but true from child steps and vise versa)
    console.log('shouldUpdateStepper after form',shouldUpdateStepper, steps, newSteps)

    if(shouldUpdateStepper) {
        dispatch(updateStepper({flowName: newFlowName, steps: newSteps}))
    }

    setTimeout(() => dispatch(setTriggerNextStep(true)),10) //just in case, to let the stepper be updated on time for next step trigger
}


const handleHugFormStep = ({course, steps, values, setFieldValue}) => {
    const hugForm = getHugFormId()
    let newSteps = [...steps]
    let shouldUpdateStepper = false;

    if(course) {
        //hug with form selected and there is no waiver step yet, insert it before payment step
        if (hugForm && !newSteps.includes(stepOptions.WAIVER)) {
            console.log('if 1')
            const paymentStepIndex = steps.findIndex(step => step === stepOptions.PAYMENT)
            newSteps.splice(paymentStepIndex, 0, stepOptions.WAIVER);
            shouldUpdateStepper = true
        }

        //hug with form selected and there is already waiver step, check if it's the same waiver- if not, reset digitalFormInfo
        else if(hugForm && newSteps.includes(stepOptions.WAIVER)) {
            console.log('if 2')
            const digitalFormInfo = values.digitalFormInfo
            if(digitalFormInfo && (digitalFormInfo?.digital_form?.id !== hugForm)) {
                setFieldValue('digitalFormInfo', null)
            }
        }

        //hug with no form was selected, but there is a waiver step (might selected a different hug, which has a form, and then switched)- remove the waiver step and the digitalFormInfo todo check how
        else if(!hugForm) {
            console.log('if 3')
            const filtered = newSteps.filter(step => step !== stepOptions.WAIVER)
            if(newSteps.length !== filtered.length) {
                shouldUpdateStepper = true
                newSteps = filtered
            }
            setFieldValue('digitalFormInfo', null)
        }
    }
    return {newSteps, shouldUpdateStepper}
}

export const getHugFormId = () => {
    const box = store.getState().site.box
    const flags = store.getState().stepper.flags ?? {}
    if(!flags.courseInfo) return null
    const hugimFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === HUGIM_FORM_SETTINGS) ?? []
    if(hugimFormSetting.length === 0) return null
    const hugFormSetting = hugimFormSetting.find(s => s.properties?.hugim?.includes(flags.courseInfo.id))
    return hugFormSetting ? hugFormSetting.properties.form_id : null
}

export const getTrialHugFormId = () => {
    const box = store.getState().site.box
    const hugimFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === HUGIM_FORM_SETTINGS) ?? []
    if(hugimFormSetting.length === 0) return null
    const trialHugFormSetting = hugimFormSetting.find(s => !!s.properties?.allowTrial)
    return trialHugFormSetting ? trialHugFormSetting.properties.form_id : null
}